export const ImportExportDevLogsMockData = [
  {
    id: '1234',
    trace: 'MockTraceDescription',
    traceId: 'MockTraceId',
    message: 'MockImportExportDevLogMessage',
    date: '2023-07-27T19:35:16.1964757+00:00',
    statusCode: 200,
  },
] as any[];

export const ScopeLogsMockData = [
  {
    id: 'MockId',
    scopeId: 'MockScopeId',
    previousParentId: 'MockPreviousParentId',
    currentParentId: 'MockCurrentParentId',
    source: 'MockSource',
    currentHierarchy: 'MockCurrentHierarcy',
    previousHierarchy: 'MockPreviousHierarcy',
    scopeLogType: 'Update',
    date: '2023-07-27T19:35:16.1964757+00:00',
    scopeLogDescendants: [
      {
        id: 'MockId',
        scopeId: 'MockScopeId',
        currentParentId: 'MockPreviousParentId',
        currentHierarchy: 'MockCurrentHierarcy',
        previousHierarchy: 'MockPreviousHierarcy',
      },
    ],
  },
] as any[];
